<template>
    <div>
        <!-- User Interface controls -->
        <b-row>
            <b-col md="7" class="my-1">
                <b-form-group class="mb-0">
                    <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search" />
                        <b-input-group-append>
                            <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="5" class="my-1">
                <b-form-group label-cols-md="4" label="Per page" class="mb-0">
                    <b-form-select :options="pageOptions" v-model="perPage" />
                </b-form-group>
            </b-col>
        </b-row>

        <!-- Main table element -->
            <b-table show-empty empty-text="Please wait while the evaluations load." striped responsive stacked="md" 
                 :items="items" 
                 :fields="fields" 
                  :filter="filter" 
                  :sort-by.sync="sortBy"
				 :sort-desc.sync="sortDesc"
                 @filtered="onFiltered">
			<template v-slot:cell(created_at)="row">
				{{ moment(row.item.created_at).format('MM.DD.YY') }}
			</template>
<template v-slot:cell(actions)="row" class="text-nowrap">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-button-group>
                    <b-button @click="viewEvaluation(row.item.id)" class="btn btn-success">
                        <span class="icon icon-eye">
                            View</span>
                    </b-button>
                </b-button-group>
            </template>
</b-table>
	<b-row>
          <b-col md="6" class="my-1">
            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
          </b-col>
        </b-row>

</div>
</template>

<script>
	const items = [];
	var moment = require('moment');
	export default {
		props: ['formatives', 'surl'],
		data() {
			return {
				items: this.formatives,
				url: this.surl,
				moment: moment,
				fields: [{
						key: "user.name",
						label: "Student",
					},
						 {
						key: "period",
						label: "Formative Period",
					},
					{
						key: "created_at",
						label: "Sent",
					},
					{
						key: "actions",
						label: "Action"
					}
				],
				filter: null,
				sortBy: "created_at",
				sortDesc: false,
				totalRows: this.formatives.length,
				pageOptions: [15, 25, 35, 50],
				currentPage: 1,
				perPage: 25,
			};
		},
		computed: {
			sortOptions() {
				// Create an options list from our fields
				return this.fields.filter(f => f.sortable).map(f => {
					return {
						text: f.label,
						value: f.key
					};
				});
			}
		},
		filters: {
			uppercase: function(v) {
				return v.toUpperCase();
			}
		},
		methods: {
			onFiltered(filteredItems) {
				// Trigger pagination to update the number of buttons/pages due to filtering
				this.totalRows = filteredItems.length;
				this.currentPage = 1;
			},
			viewEvaluation(id) {
				window.location.href = this.surl + id;
			},
		},
	};
</script>

<!-- table-complete-1.vue -->